import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { Card } from 'components/Card';
import {
  EditButton,
  PersonalInfo,
  Row,
  Wrap,
} from 'pages/User/_shared/entityDetails/styled';
import { APP_ROUTES } from 'router/appRoutes';
import { PENCIL_SVG } from 'components/ui/_shared/SVG';
import { performanceDetails } from 'store/performanceDetails';
import { appDateFormat, status } from 'utils/const';
import { format } from 'date-fns';
import { createPerformance } from 'store/createPerformance';
import { events } from 'store/events';
import { routines } from 'store/routines';
import { CardLoader } from 'pages/User/_shared/entityDetails/CardLoader';
import { CardHeaderStyled } from '../../_shared/styled';
import { DancersWrap, Info, LinkStyled } from './styled';

export const PerformanceInfo = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector(performanceDetails.selectors.performanceInfo);
  const eventsList = useSelector(events.selectors.list);
  const routinesList = useSelector(routines.selectors.routinesList);
  const dataLoadingStatus = useSelector(
    performanceDetails.selectors.loadingPerformanceInfoStatus
  );
  const isLoading = dataLoadingStatus === status.PENDING;
  const dataLoaded = dataLoadingStatus === status.SUCCESS;

  const routineTypes = data?.routine_types;

  const onRedirectToEditPage = () => {
    const isRoutine = data?.is_routine;

    dispatch(
      createPerformance.actions.setobjectForCreatePerformance({
        name: isRoutine ? data.routine_title : data.event_name,
        dancers: data.dancers,
        objectList: isRoutine
          ? eventsList.map((event) => ({
              label: event.name,
              value: event.id,
            }))
          : routinesList.map((routine) => ({
              label: routine.title,
              value: routine.id,
              dancers: routine.dancers.map((d) => ({
                label: d.full_name,
                value: d.id,
                path: d.image,
              })),
            })),
        isRoutine: data.is_routine,
      })
    );

    navigate(`${APP_ROUTES.user.performances.create}?edit=${id}`);
  };

  if (isLoading) {
    return <CardLoader />;
  }

  return (
    <Card>
      {dataLoaded && (
        <Wrap>
          <div>
            <CardHeaderStyled>
              <div>Showcase Info</div>
              <EditButton onClick={onRedirectToEditPage}>
                <PENCIL_SVG size={20} />
              </EditButton>
            </CardHeaderStyled>
          </div>

          <PersonalInfo>
            <Row>
              <div>
                <strong>Date</strong>
                {data?.date ? (
                  <p>
                    {format(
                      data?.timestamp,
                      appDateFormat.M_SHORT_D_FULL_Y_TIME
                    )}
                  </p>
                ) : (
                  <p> - </p>
                )}
              </div>
            </Row>

            <Row>
              <div>
                <strong>Event</strong>
                {data.event_name ? (
                  <p>
                    <LinkStyled
                      to={APP_ROUTES.user.events.details.index.replace(
                        ':id',
                        data.event_id
                      )}
                    >
                      @{data.event_name}
                    </LinkStyled>
                  </p>
                ) : (
                  <p>-</p>
                )}
              </div>
            </Row>

            <Row>
              <div>
                <strong>Event Entry ID</strong>
                <p>{data.entryId || '-'}</p>
              </div>
            </Row>

            <Row>
              <div>
                <strong>Progress</strong>

                {data.routine_title ? (
                  <Row style={{ display: 'flex' }}>
                    <LinkStyled
                      to={APP_ROUTES.user.routines.details.index.replace(
                        ':id',
                        data.routine_id
                      )}
                    >
                      #{data.routine_title}
                    </LinkStyled>
                    &nbsp;{routineTypes?.length ? `(${routineTypes})` : ''}
                  </Row>
                ) : (
                  <p>'-'</p>
                )}
              </div>
            </Row>

            <Row>
              <div>
                <strong>Score</strong>
                <p>{data.score || '-'}</p>
              </div>
            </Row>
          </PersonalInfo>

          <DancersWrap>
            <Info>
              <strong>Total Students: {data.dancersCount}</strong>
            </Info>
          </DancersWrap>
        </Wrap>
      )}
    </Card>
  );
};
